 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"1bfc9850","1":"f69d47cf1f6da41bd67f44b34868633f3d1f1aeb","2":"styles","3":"6bd3fbca845e4b1652bd68a9fd89d8f71227a0b1","6":"component---cache-caches-gatsby-plugin-offline-app-shell-js","7":"component---src-pages-404-js","8":"component---src-pages-about-me-js","9":"component---src-pages-content-articles-all-the-apps-that-i-use-mdx","10":"component---src-pages-content-articles-books-vs-audiobooks-mdx","11":"component---src-pages-content-articles-dealing-with-youtube-mdx","12":"component---src-pages-content-articles-how-books-have-influenced-my-life-mdx","13":"component---src-pages-content-articles-how-the-rubiks-cube-ismore-than-a-puzzle-mdx","14":"component---src-pages-content-articles-how-to-build-habits-that-stick-mdx","15":"component---src-pages-content-articles-how-to-fall-asleep-faster-mdx","16":"component---src-pages-content-articles-how-to-practise-phone-distancing-mdx","17":"component---src-pages-content-articles-my-note-taking-workflow-mdx","18":"component---src-pages-content-articles-online-vs-offline-studying-student-perpective-mdx","19":"component---src-pages-content-articles-rr-effectively-using-the-daily-note-mdx","20":"component---src-pages-content-articles-rr-intro-and-uses-mdx","21":"component---src-pages-content-articles-rr-weekly-reviews-and-queries-mdx","22":"component---src-pages-content-articles-the-myth-about-programming-mdx","23":"component---src-pages-content-articles-why-is-sleep-so-necessary-mdx","24":"component---src-pages-content-books-flipped-mdx","25":"component---src-pages-content-books-how-to-take-smart-notes-mdx","26":"component---src-pages-content-books-the-alchemist-mdx","27":"component---src-pages-content-books-the-four-hour-work-week-mdx","28":"component---src-pages-content-newsletters-newsletter-1-mdx","29":"component---src-pages-content-newsletters-newsletter-10-mdx","30":"component---src-pages-content-newsletters-newsletter-11-mdx","31":"component---src-pages-content-newsletters-newsletter-12-mdx","32":"component---src-pages-content-newsletters-newsletter-13-mdx","33":"component---src-pages-content-newsletters-newsletter-14-mdx","34":"component---src-pages-content-newsletters-newsletter-15-mdx","35":"component---src-pages-content-newsletters-newsletter-2-mdx","36":"component---src-pages-content-newsletters-newsletter-3-mdx","37":"component---src-pages-content-newsletters-newsletter-4-mdx","38":"component---src-pages-content-newsletters-newsletter-5-mdx","39":"component---src-pages-content-newsletters-newsletter-6-mdx","40":"component---src-pages-content-newsletters-newsletter-7-mdx","41":"component---src-pages-content-newsletters-newsletter-8-mdx","42":"component---src-pages-content-newsletters-newsletter-9-mdx","43":"component---src-pages-index-js","44":"component---src-pages-newsletter-js","45":"component---src-pages-notes-js","46":"component---src-pages-tags-js","47":"component---src-template-blog-post-js","48":"component---src-template-tags-js"}[chunkId]||chunkId) + "-" + {"0":"79e54525f8697c49b93c","1":"887330f48f271b2efc05","2":"7d4153d260c0197f0043","3":"06f0e676eccc7d449ab5","6":"d3ee03be2ef85643f368","7":"d6ba377a3752b9a5e039","8":"5ea6cac0daa8a7ffe9aa","9":"0ef1e58de3441813e6f0","10":"1ca13fcc797dc79c54a2","11":"45c77f44d40d94cc4baa","12":"4a73173e24c9c607f0a0","13":"1e6ab4eba967d9be8562","14":"5972c68334014427eddd","15":"6cdcc12fa5347f15845d","16":"07e77253cae1c05fa01f","17":"6e415f4c4a251b5f713e","18":"07f9ba5bb01929cab68e","19":"5a32c5096a5400edfa49","20":"3de768a12b7576ae6417","21":"11b7ebbd5e1a58b9bc9f","22":"733125b650ad67d7e26a","23":"57d57058c7885a98c820","24":"369896cb1c7c14f445f0","25":"5d19aa114a5bd7b10d29","26":"416dc4422c32803511a3","27":"73fb7ba2cc2d4953177c","28":"da9f0651e078e97ed518","29":"31568e819eb723f0fb91","30":"d21145e42b463f7ad4c7","31":"8204aefc436dfdeb1c38","32":"0a1cfc96653600753b15","33":"9e6ba042350f5120bb8e","34":"71e6452f8489071d4ba6","35":"17e8e92f28a57252cb6e","36":"70c808384e3374b31622","37":"e4f725598b5587d34465","38":"9a89e6bdb9d338923f71","39":"a46563f020827fda1b9f","40":"afaec884892eb2e5a195","41":"c6f283a5634e314d8265","42":"84b38aae12e2c6b0aee9","43":"0091b9099fc8daa895e5","44":"93030aa10926b5d5990a","45":"d8c6dd1d4ad93619a249","46":"39059d5e73bac30b1195","47":"999e7f45638996cb990e","48":"707037b7880fb0aa8b16"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"1bfc9850","1":"f69d47cf1f6da41bd67f44b34868633f3d1f1aeb","2":"styles","3":"6bd3fbca845e4b1652bd68a9fd89d8f71227a0b1","6":"component---cache-caches-gatsby-plugin-offline-app-shell-js","7":"component---src-pages-404-js","8":"component---src-pages-about-me-js","9":"component---src-pages-content-articles-all-the-apps-that-i-use-mdx","10":"component---src-pages-content-articles-books-vs-audiobooks-mdx","11":"component---src-pages-content-articles-dealing-with-youtube-mdx","12":"component---src-pages-content-articles-how-books-have-influenced-my-life-mdx","13":"component---src-pages-content-articles-how-the-rubiks-cube-ismore-than-a-puzzle-mdx","14":"component---src-pages-content-articles-how-to-build-habits-that-stick-mdx","15":"component---src-pages-content-articles-how-to-fall-asleep-faster-mdx","16":"component---src-pages-content-articles-how-to-practise-phone-distancing-mdx","17":"component---src-pages-content-articles-my-note-taking-workflow-mdx","18":"component---src-pages-content-articles-online-vs-offline-studying-student-perpective-mdx","19":"component---src-pages-content-articles-rr-effectively-using-the-daily-note-mdx","20":"component---src-pages-content-articles-rr-intro-and-uses-mdx","21":"component---src-pages-content-articles-rr-weekly-reviews-and-queries-mdx","22":"component---src-pages-content-articles-the-myth-about-programming-mdx","23":"component---src-pages-content-articles-why-is-sleep-so-necessary-mdx","24":"component---src-pages-content-books-flipped-mdx","25":"component---src-pages-content-books-how-to-take-smart-notes-mdx","26":"component---src-pages-content-books-the-alchemist-mdx","27":"component---src-pages-content-books-the-four-hour-work-week-mdx","28":"component---src-pages-content-newsletters-newsletter-1-mdx","29":"component---src-pages-content-newsletters-newsletter-10-mdx","30":"component---src-pages-content-newsletters-newsletter-11-mdx","31":"component---src-pages-content-newsletters-newsletter-12-mdx","32":"component---src-pages-content-newsletters-newsletter-13-mdx","33":"component---src-pages-content-newsletters-newsletter-14-mdx","34":"component---src-pages-content-newsletters-newsletter-15-mdx","35":"component---src-pages-content-newsletters-newsletter-2-mdx","36":"component---src-pages-content-newsletters-newsletter-3-mdx","37":"component---src-pages-content-newsletters-newsletter-4-mdx","38":"component---src-pages-content-newsletters-newsletter-5-mdx","39":"component---src-pages-content-newsletters-newsletter-6-mdx","40":"component---src-pages-content-newsletters-newsletter-7-mdx","41":"component---src-pages-content-newsletters-newsletter-8-mdx","42":"component---src-pages-content-newsletters-newsletter-9-mdx","43":"component---src-pages-index-js","44":"component---src-pages-newsletter-js","45":"component---src-pages-notes-js","46":"component---src-pages-tags-js","47":"component---src-template-blog-post-js","48":"component---src-template-tags-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"1fdfb6111825370edc62","3":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
